import React from "react";
import {t} from "@lingui/core/macro";
import {LANGS} from "../../../i18n";
import styles from "./v2.module.css";

// Le libellé historique de LANGS s'écrit sans cédille.
const labelOf = (lang) => (lang.value === "fr" ? "Français" : lang.formatLabel)

/**
 * Sélecteur de langue de la maquette : un simple bouton « FR » sur téléphone,
 * « Français » sur ordinateur. C'est un vrai <select> natif posé par-dessus :
 * liste système au toucher, clavier et lecteurs d'écran sans code en plus.
 * Même redirection que les autres thèmes (préfixe de langue dans l'adresse).
 */
export default function LangSwitch({context}) {
    const {org, lang} = context
    if (!Array.isArray(org?.languages) || org.languages.length === 0) return null

    const defaultLanguage = org.language || "fr"
    const values = [defaultLanguage, ...org.languages.filter(value => value !== defaultLanguage)]
    const options = values.map(value => LANGS.find(item => item.value === value)).filter(Boolean)
    const current = options.find(item => item.value === (lang?.value || defaultLanguage)) || options[0]
    if (!current) return null

    const onChange = (key) => {
        const base = org.BASE_WEB_URL.split("/")
        // Les paramètres sont ré-encodés : recollés bruts, une valeur contenant « & »
        // ou « = » (un lien de suivi, par exemple) se scindait en plusieurs paramètres.
        const query = new URLSearchParams()
        for (const name of Object.keys(context.query || {})) {
            // « merci » rouvrirait l'écran de remerciement dans l'autre langue.
            if (name === "router" || name === "merci") continue
            const value = context.query[name]
            if (Array.isArray(value)) value.forEach(item => query.append(name, item))
            else query.append(name, value)
        }

        if (LANGS.find(item => item.value === base[base.length - 1])) {
            base[base.length - 1] = key
        } else {
            base.push(key)
        }

        let url = base.concat(context.route || []).join("/")
        const search = query.toString()
        if (search) url += "?" + search
        window.location.href = url
    }

    return (
        <label className={styles.lang}>
            <span className={styles.langShort} aria-hidden="true">{current.value.toUpperCase()}</span>
            <span className={styles.langLong} aria-hidden="true">{labelOf(current)}</span>
            <select
                className={styles.langSelect}
                aria-label={t`Langue`}
                value={current.value}
                onChange={(e) => onChange(e.target.value)}
            >
                {options.map(item => (
                    <option key={item.value} value={item.value} lang={item.value}>{labelOf(item)}</option>
                ))}
            </select>
        </label>
    )
}
